import { publicHolidays } from "../data/holidays";

interface ModalContentParams {
  lastTaskUpdatedAt: string | null | undefined;
  now: Date;
}

/**
 * 완료 버튼 클릭 시 표시될 모달의 제목과 부제를 결정하는 함수
 * @param params - lastTaskUpdatedAt: 마지막 과제 업데이트 시간, now: 현재 시간 (클릭 시점)
 * @returns { title: string, subtitle: string }
 */
export const getDoneModalContent = ({
  lastTaskUpdatedAt,
  now,
}: ModalContentParams): { title: string; subtitle: string } => {
  const isHoliday = (date: Date): boolean => {
    const dayOfWeek = date.getDay();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      return true;
    }
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return publicHolidays.includes(formattedDate);
  };

  try {
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const isTodayHoliday_ = isHoliday(today);
    const isTomorrowHoliday_ = isHoliday(tomorrow);

    let title = "";
    let subtitle = "";

    // 분기 1: 오늘이 휴일인 경우
    if (isTodayHoliday_) {
      subtitle = "휴일은 코치 선생님도 쉬는 날이랍니다.";
      if (isTomorrowHoliday_) {
        title = "휴일 이후 다음 활동이 준비돼요";
      } else {
        title = "내일 다음 활동이 준비돼요";
      }
    }
    // 분기 2: 오늘이 평일인 경우
    else {
      const lastUpdateDate = lastTaskUpdatedAt
        ? new Date(lastTaskUpdatedAt)
        : null;
      const today8AM = new Date(today);
      today8AM.setHours(8, 0, 0, 0);
      const today3PM = new Date(today);
      today3PM.setHours(15, 0, 0, 0);

      const wasUpdatedAfter8AM = lastUpdateDate
        ? lastUpdateDate > today8AM
        : false; // 당일 8시 이후로 업데이트 받은

      // 15시 이후 마침
      const isFinishingAfter3PM = now > today3PM;

      // 분기 2-1: 오늘이 평일이고, 내일이 휴일인 경우
      if (isTomorrowHoliday_) {
        if (wasUpdatedAfter8AM) {
          title = "휴일 이후 다음 활동이 준비돼요";
          subtitle = "활동은 하루에 한 번 업데이트 돼요.";
        } else if (isFinishingAfter3PM) {
          title = "휴일 이후 다음 활동이 준비돼요";
          subtitle =
            "평일 오후 3시 이후에 활동을 마치면 다음 업무일에 새 활동이 준비돼요.";
        } else {
          title = "오늘 내로 다음 활동이 준비돼요";
          subtitle =
            "코치 선생님이 확인 후 연락을 드릴 거예요. 조금만 기다려주세요.";
        }
      }
      // 분기 2-2: 오늘이 평일이고, 내일도 평일인 경우
      else {
        if (wasUpdatedAfter8AM) {
          title = "내일 다음 활동이 준비돼요";
          subtitle = "활동은 하루에 한 번 업데이트 돼요.";
        } else if (isFinishingAfter3PM) {
          title = "내일 다음 활동이 준비돼요";
          subtitle =
            "평일 오후 3시 이후에 활동을 마치면 다음 업무일에 새 활동이 준비돼요.";
        } else {
          title = "오늘 내로 다음 활동이 준비돼요";
          subtitle =
            "코치 선생님이 확인 후 연락을 드릴 거예요. 조금만 기다려주세요.";
        }
      }
    }

    return { title, subtitle };
  } catch (e) {
    return {
      title: "주어진 활동을 모두 마쳤어요",
      subtitle: "평일 업무시간에 코치 선생님이 확인 후에 메시지를 드릴 거예요.",
    };
  }
};